import { getType, Instance, isStateTreeNode } from 'mobx-state-tree'
import { Question } from '../models/Question'

export const isQuestion = (value: any): value is Instance<typeof Question> => {
  return isStateTreeNode(value) && getType(value).name === 'Question'
}
